import { namespace, Distance } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * @param {Bounds} bounds
 * @param {string} axis
 * @return {number}
 */
function getSizeByAxis(bounds, axis) {
    const sizeFunctionName = {
        x: 'getWidth',
        y: 'getHeight',
    };
    return bounds[sizeFunctionName[axis]]();
}

/**
 * @param {AbstractItem[]} items
 * @return {Bounds}
 */
function getCollectionBounds(items) {
    let bounds = null;

    items.forEach((item) => {
        if (bounds) {
            bounds = bounds.merge(item.getBounds());
        } else {
            bounds = item.getBounds();
        }
    });

    return bounds;
}

/**
 * @class AlignItemsByBorderCommand
 * @extends AbstractCommand
 */
export default class AlignItemsByBorderCommand extends AbstractCommand {
    constructor(items, border) {
        super();

        if (!Array.isArray(items) || items.length <= 1) {
            throw new Error('Too few items are selected.');
        }

        this.items = items;
        this.alignBorder = border;
        this.alignVertical = (border === 'top' || border === 'bottom');
        this.alignOnFirstBorder = (border === 'top' || border === 'left');
        this.initialPositions = {};

        this.items.forEach(item => (this.initialPositions[item.cid] = item.get('position').clone()));
    }

    /**
     * Execute command
     */
    execute() {
        const axis = this.alignVertical ? 'y' : 'x';
        const bounds = getCollectionBounds(this.items);

        let newPos;

        if (this.alignOnFirstBorder) {
            newPos = bounds.getTopLeft()[axis];
        } else {
            newPos = bounds.getBottomRight()[axis];
        }

        this.items.forEach((item) => {
            const initialPosition = item.get('position').clone();
            const itemBounds = item.getBounds();
            const distance = new Distance(initialPosition, itemBounds.getCenter()).point;
            const halfItemSize = getSizeByAxis(itemBounds, axis) / 2;

            if (this.alignOnFirstBorder) {
                initialPosition[axis] = (newPos + halfItemSize) - distance[axis];
            } else {
                initialPosition[axis] = (newPos - halfItemSize) - distance[axis];
            }
            item.set('position', initialPosition);
        });
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.items.forEach(item => item.set('position', this.initialPositions[item.cid]));
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Align items by ${this.alignBorder} border`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.AlignItemsByBorderCommand = AlignItemsByBorderCommand;
